<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9 14.25C9 15.0784 8.32843 15.75 7.5 15.75C6.67157 15.75 6 15.0784 6 14.25M9 14.25C9 13.4216 8.32843 12.75 7.5 12.75M9 14.25H14.25M6 14.25C6 13.4216 6.67157 12.75 7.5 12.75M6 14.25H0.75M7.5 12.75V9.75M14.25 3C14.25 4.24264 11.2279 5.25 7.5 5.25C3.77208 5.25 0.75 4.24264 0.75 3M14.25 3C14.25 1.75736 11.2279 0.75 7.5 0.75C3.77208 0.75 0.75 1.75736 0.75 3M14.25 3V7.5C14.25 8.745 11.25 9.75 7.5 9.75M0.75 3V7.5C0.75 8.745 3.75 9.75 7.5 9.75"
    stroke="var(--stroke-color)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
